import { useEffect, useState } from "react";

import { loadChurchAttendanceAppWorkspace } from "../../services/churchAttendanceService";

export default function AttendanceWidget() {
  const [stats, setStats] = useState({ latest: 0, date: "No record" });

  useEffect(() => {
    let mounted = true;

    async function load() {
      try {
        const workspace = await loadChurchAttendanceAppWorkspace(null);
        const latest = workspace.attendance?.[0] || null;
        if (mounted) {
          setStats({
            latest: latest?.worshipCount || 0,
            date: latest?.attendanceDate || "No record",
          });
        }
      } catch (error) {
        console.error("Attendance widget load error:", error);
      }
    }

    load();

    return () => {
      mounted = false;
    };
  }, []);

  return (
    <div style={styles.widget}>
      <div style={styles.kicker}>Attendance</div>
      <div style={styles.title}>{stats.latest}</div>
      <div style={styles.text}>Latest worship • {stats.date}</div>
    </div>
  );
}

const styles = {
  widget: {
    background: "linear-gradient(135deg, #f7fbf7, #eef7f0)",
    border: "1px solid #dbe8dc",
    borderRadius: 8,
    boxShadow: "0 16px 38px rgba(37, 53, 45, 0.1)",
    minHeight: 132,
    padding: 18,
  },
  kicker: {
    color: "#64748b",
    fontSize: 12,
    fontWeight: 900,
    textTransform: "uppercase",
  },
  title: {
    color: "#0f172a",
    fontSize: 40,
    fontWeight: 950,
    lineHeight: 1,
    marginTop: 10,
  },
  text: {
    color: "#475569",
    fontSize: 13,
    fontWeight: 800,
    marginTop: 10,
  },
};
